__turbopack_context__.v({
  "figure": "Gallery-module__p5_gjG__figure",
  "gallery": "Gallery-module__p5_gjG__gallery",
  "galleryContent": "Gallery-module__p5_gjG__galleryContent",
  "image": "Gallery-module__p5_gjG__image",
});
